import { SVGProps } from 'react';

export const LabelIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='12'
    height='11'
    viewBox='0 0 12 11'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <g clipPath='url(#clip0_3327_10165)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.76494 0.939453H2.28042C1.02098 0.939453 0 1.96043 0 3.21987V7.78071C0 9.04015 1.02098 10.0611 2.28042 10.0611H7.76494C8.43065 10.0611 9.06312 9.77023 9.49636 9.26479L11.451 6.98437C12.183 6.13037 12.183 4.87021 11.451 4.01621L9.49636 1.7358C9.06312 1.23035 8.43065 0.939453 7.76494 0.939453ZM1.14021 3.21987C1.14021 2.59015 1.6507 2.07966 2.28042 2.07966H7.76494C8.09779 2.07966 8.41403 2.22511 8.63065 2.47783L10.5853 4.75825C10.9513 5.18525 10.9513 5.81533 10.5853 6.24233L8.63065 8.52275C8.41403 8.77547 8.09779 8.92092 7.76494 8.92092H2.28042C1.6507 8.92092 1.14021 8.41043 1.14021 7.78071V3.21987Z'
      />
    </g>
    <defs>
      <clipPath id='clip0_3327_10165'>
        <rect width='12' height='9.12168' fill='white' transform='translate(0 0.939453)' />
      </clipPath>
    </defs>
  </svg>
);
